var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwitchTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.99935C18.3334 14.5993 14.6 18.3327 10 18.3327C5.40002 18.3327 2.59169 13.6993 2.59169 13.6993M2.59169 13.6993H6.35835M2.59169 13.6993V17.866M1.66669 9.99935C1.66669 5.39935 5.36669 1.66602 10 1.66602C15.5584 1.66602 18.3334 6.29935 18.3334 6.29935M18.3334 6.29935V2.13268M18.3334 6.29935H14.6334",
    stroke: "#525252",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTeam);
export default __webpack_public_path__ + "static/media/switch-team.25801ba549a80ff5e71d1a7864e859d9.svg";
export { ForwardRef as ReactComponent };